module.exports = __webpack_public_path__ + "static/img/mzlb.9d33397.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s35/mzlb.gif
// module id = ZGUR
// module chunks = 2